function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useRef, useState, useMemo } from "react";
import { arrayOf, string } from "prop-types";
import classNamesMaker from "classnames";
import { Dropdown } from "#library/components/Dropdown";
import { MenuBarProvider, defaultValue } from "./MenuBarContext";
import { MenuBarLink } from "./Link/MenuBarLink";
import { MenuBarDropdown } from "./Dropdown/MenuBarDropdown";
import { ButtonShowAll } from "./Button/ButtonShowAll";
import { MenuBarModal } from "./Modal/MenuBarModal";
import { MODAL_CHILDREN_ITEMS } from "./constants";
import styles from "./menuBar.module.css";
var VALID_CHILDREN = [MenuBarLink, MenuBarDropdown];
export var MenuBar = function MenuBar(_ref) {
  var children = _ref.children,
    labelButtonShowAll = _ref.labelButtonShowAll;
  var refNav = useRef(null);
  var refButton = useRef(null);
  var refList = useRef(null);
  var _useState = useState(defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    providerValues = _useState2[0],
    setProviderValues = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    modalIsOpen = _useState4[0],
    setModalIsOpen = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    dropdownItems = _useState6[0],
    setDropdownItems = _useState6[1];

  // use of useMemo to avoid infinite re-renders
  var childrenArray = useMemo(function () {
    return React.Children.toArray(children);
  }, [children]);
  var totalLinks = childrenArray.reduce(function (acc, child) {
    if (child.type.name === MODAL_CHILDREN_ITEMS.LINK) {
      return acc + 1;
    }
    return acc;
  }, 0);
  var withLinksOnly = totalLinks === childrenArray.length;
  var buttonClassNames = classNamesMaker(styles["jds-MenuBar__item"], styles["jds-MenuBar__item--showAll"]);
  var handleOpenModal = function handleOpenModal() {
    setModalIsOpen(!modalIsOpen);
  };
  useEffect(function () {
    var _refButton$current$ge = refButton.current.getBoundingClientRect(),
      width = _refButton$current$ge.width;
    setProviderValues({
      marginWidth: width,
      parentRef: refNav.current
    });
  }, [refNav, refButton]);
  useEffect(function () {
    var currentList = refList.current;
    function handleResize() {
      if (currentList) {
        var listItems = Array.from(currentList.children).map(function (item, index) {
          if (item.className.includes("noVisible")) {
            return childrenArray[index];
          }
          return null;
        }).filter(Boolean);
        setDropdownItems(listItems);
      }
    }

    /* Use a timer to allow time for the Intersection Observer API to hide non-visible elements in the interface */
    setTimeout(function () {
      handleResize();
    }, 200);
    window.addEventListener("resize", handleResize);
    return function () {
      window.removeEventListener("resize", handleResize);
    };
  }, [refList, childrenArray]);

  /**
   * This function checks among all the invisible MenuBarLinks
   * (those visible in the dropdown) if one has the "selected" props
   *
   * @return {boolean} Wether or not any dropdown item is selected
   */
  var isAnyDropdownItemSelected = function isAnyDropdownItemSelected() {
    return React.Children.toArray(dropdownItems).some(function (_ref2) {
      var props = _ref2.props;
      // eslint-disable-next-line react/prop-types
      return props === null || props === void 0 ? void 0 : props.selected;
    });
  };

  /**
   * This function checks among all the invisible MenuBarDropdown
   * (those only visible in the modal) if one has its
   * TriggerMenuItem with the "selected" props
   *
   * @return {boolean} Wether or not any invisble dropdown has any selected item
   */
  var isAnyInvisibleDropdownWithSelectedItem = function isAnyInvisibleDropdownWithSelectedItem() {
    return React.Children.toArray(dropdownItems).some(function (_ref3) {
      var _props$children$;
      var props = _ref3.props;
      // eslint-disable-next-line react/prop-types
      return props === null || props === void 0 || (_props$children$ = props.children[0]) === null || _props$children$ === void 0 || (_props$children$ = _props$children$.props) === null || _props$children$ === void 0 ? void 0 : _props$children$.selected;
    });
  };
  return /*#__PURE__*/React.createElement(MenuBarProvider, {
    initialValue: providerValues
  }, /*#__PURE__*/React.createElement("nav", {
    ref: refNav,
    className: styles["jds-MenuBar"]
  }, /*#__PURE__*/React.createElement("ul", {
    ref: refList,
    className: styles["jds-MenuBar__list"]
  }, children, /*#__PURE__*/React.createElement("li", {
    ref: refButton,
    className: buttonClassNames
  }, withLinksOnly && /*#__PURE__*/React.createElement(Dropdown, {
    placement: "bottom-end",
    className: styles["jds-MenuBar__dropdown--withLinksOnly"]
  }, /*#__PURE__*/React.createElement(Dropdown.TriggerMenuItem, {
    selected: isAnyDropdownItemSelected()
  }, labelButtonShowAll), /*#__PURE__*/React.createElement(Dropdown.Menu, null, dropdownItems.map(function (child, index) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement(Dropdown.Item, _extends({}, child.props, {
        key: index
      }))
    );
  }))), /*#__PURE__*/React.createElement(ButtonShowAll, {
    className: classNamesMaker(styles["jds-MenuBar__buttonShowAll"], _defineProperty({}, styles["jds-MenuBar__buttonShowAll--withLinksOnly"], withLinksOnly)),
    selected: !withLinksOnly ? isAnyInvisibleDropdownWithSelectedItem() : isAnyDropdownItemSelected(),
    label: labelButtonShowAll,
    onClick: handleOpenModal
  })))), /*#__PURE__*/React.createElement(MenuBarModal, {
    title: labelButtonShowAll,
    onClose: handleOpenModal,
    isOpen: modalIsOpen
  }, children));
};
MenuBar.Link = MenuBarLink;
MenuBar.Dropdown = MenuBarDropdown;
MenuBar.defaultProps = {
  labelButtonShowAll: "All categories"
};
MenuBar.propTypes = {
  labelButtonShowAll: string,
  children: arrayOf(
  // eslint-disable-next-line max-params
  function (propValue, key, componentName, location, propFullName) {
    var _propValue$key;
    var currentType = (_propValue$key = propValue[key]) === null || _propValue$key === void 0 ? void 0 : _propValue$key.type;
    var isMenuBarItem = VALID_CHILDREN.includes(currentType);
    if (!isMenuBarItem) {
      return new Error("Invalid prop: ".concat(propFullName, " supplied to ").concat(componentName, ". Validation failed."));
    }
    return true;
  }).isRequired
};